var module = angular.module('octopusApp.environments');

module.controller('EnvironmentIndexController', function ($scope, $rootScope, $location, $state, $q, $localStorage, busy, octopusRepository, octoDialog, octopusTagSets) {
    var isLoading = $scope.isLoading = busy.create();

    var defaultMode = "default";
    var hostedMode = "hosted";
    $scope.page = {
        mode: defaultMode,
        modeName: function() {
            return ($scope.page.mode === defaultMode) ? "Show Hosted Agent" : "Show Deployment Targets";
        }
    };
    $scope.environments = null;
    $scope.machines = {};
    $scope.tentaclesUnavailable = [];
    $scope.tagSets = null;
    $scope.upgradesRequired = false;
    $scope.showUpgrade = ($localStorage.ignoreUpgradeVersion !== $rootScope.octopusVersion);
    $scope.showAzureTargetsWarning = false;
    $scope.hasLoaded = false;

    function isVisible(environment) {
        return ($scope.page.mode === environment.showFor);
    }

    function init() {
        var environmentsP  = octopusRepository.Environments.all().then(function(environments) {
            environments.forEach(function(environment){
                if (!environment.showFor) {
                    environment.showFor = defaultMode;
                }
                environment.visible = isVisible;
            });
            $scope.environments = environments;
        });

        var machinesP = octopusRepository.Machines.all().then(function (machines) {
            var hasDeprecatedAzureTargets = false;

            machines.forEach(function (machine) {
                octopusTagSets.getTag(machine.TenantTags).then(function (tags) {
                    machine.selectedTags = tags;
                });

                machine.EnvironmentIds.forEach(function (environmentId) {
                    var group = machine.HealthStatus;

                    if (!$scope.machines[environmentId]) {
                        $scope.machines[environmentId] = {};
                    }
                    
                    if (!$scope.tentaclesUnavailable[environmentId]) {
                        $scope.tentaclesUnavailable[environmentId] = [];
                    }

                    if (machine.IsDisabled) {
                        group = "Disabled";
                    }  else if (machine.HealthStatus === "Unavailable" && machine.Endpoint.TentacleVersionDetails) {
                        $scope.tentaclesUnavailable[environmentId].push(machine);
                    } else if (machine.HealthStatus !== "Unknown" && machine.HealthStatus !== "Unavailable" && machine.HealthStatus !== "Unhealthy") { // Upgrade status shouldn't override these states
                        if (machine.Endpoint.TentacleVersionDetails &&
                            machine.Endpoint.TentacleVersionDetails.UpgradeSuggested && !machine.Endpoint.TentacleVersionDetails.UpgradeLocked) {
                            $scope.upgradesRequired = true;
                            group = "NeedsUpgrade";
                        } else if (!machine.HasLatestCalamari) {
                            group = "CalamariNeedsUpgrade";
                        }
                    }

                    if (machine.Endpoint.CommunicationStyle === 'AzureWebApp' ||
                        machine.Endpoint.CommunicationStyle === 'AzureCloudService') {
                        hasDeprecatedAzureTargets = true;
                    }

                    if (!$scope.machines[environmentId][group]) {
                        $scope.machines[environmentId][group] = [];
                    }
                    $scope.machines[environmentId][group].push(machine);
                });
            });

            $scope.showAzureTargetsWarning = hasDeprecatedAzureTargets && !$localStorage.ignoreAzureTargetsWarning;
        });

        isLoading.promise($q.all([environmentsP, machinesP]).then(function(){
            $scope.hasLoaded = true;
        }));
    }

    $scope.toggleVisibility = function() {
        if ($scope.page.mode === defaultMode) {
            $scope.page.mode = hostedMode;
        } else {
            $scope.page.mode = defaultMode;
        }
    };

    $scope.checkHealth = function (environment) {
        var task = {
            Name: 'Health',
            Description: 'Check Deployment Target health',
            Arguments: { Timeout: '00:05:00' }
        };

        if (environment) {
            task.Description += ' in ' + environment.Name;
            task.Arguments.EnvironmentId = environment.Id;
        }

        isLoading.promise(octopusRepository.Tasks.create(task).then(function(result){
            $location.path("/tasks/" + result.Id);
        }));
    };

    $scope.upgradeTentaclesInEnvironment = function (environment) {
        var task = {
            Name: 'Upgrade',
            Description: 'Upgrade Tentacles',
            Arguments: { }
        };

        if (environment) {
            task.Description += ' in ' + environment.Name;
            task.Arguments.EnvironmentId = environment.Id;
        }

        isLoading.promise(octopusRepository.Tasks.create(task).then(function(result){
            $location.path("/tasks/" + result.Id);
        }));
    };

    $scope.upgradeCalamariOnDeploymentTargets = function (environment) {
        var machineIdsThatNeedsCalamariUpgrade = _.map($scope.machines[environment.Id]['CalamariNeedsUpgrade'], function (m) { return m.Id; });
        var task = {
            Name: 'UpdateCalamari',
            Description: 'Update Calamari on Deployment Targets',
            Arguments: { 
                MachineIds: machineIdsThatNeedsCalamariUpgrade
            }
        };

        isLoading.promise(octopusRepository.Tasks.create(task).then(function(result) {
            $location.path('/tasks/' + result.Id);
        }));
    };

    $scope.upgradeTentacles = function () {
        var task = {
            Name: 'Upgrade',
            Description: 'Upgrade Tentacles'
        };

        isLoading.promise(octopusRepository.Tasks.create(task).then(function(result){
            $location.path("/tasks/" + result.Id);
        }));
    };

    $scope.dismissTentacleUpgrade = function() {
        $localStorage.ignoreUpgradeVersion = $rootScope.octopusVersion;
        $scope.showUpgrade = false;
    };
  
    $scope.dismissAzureTargetsWarning = function() {
        $localStorage.ignoreAzureTargetsWarning = true;
        $scope.showAzureTargetsWarning = false;
    };

    $scope.show = function(machine) {
        $location.path('/machines/' + machine.Id);
    };

    $scope.reorder = function() {
        octoDialog.sort({
            title: "Reorder Environments",
            saveButtonText: "Save",
            load: function(dialog) {
                dialog.render(_.map($scope.environments, function (environment) {
                    return {
                        id: environment.Id,
                        name: environment.Name
                    };
                }));
            },
            save: function (items, dialog) {
                dialog.busy.promise(octopusRepository.Environments.sort(items).then(function() {
                    dialog.dismiss();
                    $state.reload();
                }));
            }
        });
    };

    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/controllers/environment_index_controller.js
// module id = 419
// module chunks = 1